module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/modal-profile-8-image-5b0d6c04c2eb93f3536f9bd4a94e529f.png";